<template>
  <input
    type="checkbox"
    class="is-large"
    v-model="fieldData.value"
    :disabled="fieldData.loading || !fieldDefinition.editable || undefined"
  />
  <p
    class="help is-danger"
    v-for="(error, i) in [...localErrors, ...fieldData.errors]"
    :key="i"
  >
    {{ error }}
  </p>
</template>

<script setup lang="ts">
import { type FieldModel, type FieldProps, defineValidator } from '.'

type Constraint = { type: 'bool'; many: false }

const { fieldDefinition } = defineProps<FieldProps<Constraint>>()
const fieldData = defineModel<FieldModel<Constraint>>({ required: true })

const { localErrors } = defineValidator(fieldDefinition, fieldData.value)
</script>
